import Vue from 'vue'
import App from './App.vue'
import { router } from './router'
import store from './store'
import { Menu, MenuItem, Submenu, Carousel, CarouselItem, Input, Form, FormItem, Button, Message, Loading, Dialog, MessageBox, DatePicker, Table, TableColumn, Pagination, Row, Radio, RadioGroup, Select, Option } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/base.css'
import './assets/iconfont/iconfont.css'
import axios from 'axios'
import api from './api'
import Fragment from 'vue-fragment'
import moduleCardLayout from '@/components/moduleCard/index'
import authButtonComponent from '@/components/authButton/index'
import './assets/js/permission'
// require('./mock')

Vue.use(Menu).use(MenuItem).use(Submenu).use(Carousel).use(CarouselItem).use(Input)
  .use(Form).use(FormItem).use(Button).use(Loading).use(Dialog).use(DatePicker)
  .use(Table).use(TableColumn).use(Pagination).use(Row).use(Radio).use(RadioGroup)
  .use(Select).use(Option)

Vue.use(moduleCardLayout)
Vue.use(authButtonComponent)
Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$api = api
Vue.prototype.$axios = axios.create({
})
Vue.prototype.$axios.interceptors.request.use(
  config => {
    // 除登陆接口，其余接口头部都添加sessionId
    // if (config.url.includes('/cms/common-service/upload-pic')) {
    //   config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    // } else {
    config.headers['Content-Type'] = 'application/json;charset=UTF-8'
    // }
    if (!config.url.includes('home/login')) {
      config.headers['LS-SAAS-CMS-SESSIONID'] = localStorage.getItem('LS_SAAS_CMS_SESSIONID')
      config.headers['LS-SAAS-CMS-UIN'] = localStorage.getItem('LS-SAAS-CMS-UIN')
    }
    return config
  }
)
// http response 服务器响应拦截器，这里拦截401错误，并重新跳入登页重新获取token
Vue.prototype.$axios.interceptors.response.use(
  response => {
    if (!response || !response.data) {
      Message({
        type: 'error',
        message: '网络请求失败，请重试！'
      })
      return false
    }
    switch (response.data.respCode) {
      case '0': {
        return response.data
      }
      // 错误码为6说明未登录或token失效
      case '9994': {
        localStorage.clear()
        store.commit('updateUserInfo', {})
        store.commit('updateNavBar', {})
        store.commit('updateRoot', {})
        if (router.name !== 'login') {
          router.replace({
            path: '/login',
            query: { id: router.currentRoute.query.id }// 登录成功后跳入浏览的当前页面
          })
        }
        return response.data
      }
      default: {
        // 返回类型为blob时，需转换成utf-8如果含有respCode说明没有返回文件流，请求失败了，就给出错误信息
        if (response.data.toString() === '[object Blob]') {
          return new Promise((resolve) => {
            const reader = new FileReader()
            reader.readAsText(response.data, 'utf-8') // 转换成utf-8编码方式
            reader.onload = function () {
              if (reader.result.length === 0) {
                Message({
                  type: 'error',
                  message: '网络请求失败，请重试！'
                })
                resolve(false)
              } else if (!reader.result.includes('respCode')) {
                resolve(response.data)
              } else {
                const res = JSON.parse(reader.result)
                Message({
                  type: 'error',
                  message: res.respMsg
                })
                resolve(res)
              }
            }
          })
        } else {
          Message({
            type: 'error',
            message: response.data.respMsg
          })
          return response.data
        }
      }
    }
  },
  error => {
    if (error.response) {
      // Loading.service().close()
      Message({
        type: 'error',
        message: '网络请求失败，请重试！'
      })
    }
    return Promise.reject(error.response)
  }
)

Vue.use(Fragment.Plugin)
Vue.config.productionTip = false

Vue.directive('loadmore', {
  bind (el, binding) {
    // 获取element-ui定义好的scroll盒子
    const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap')
    SELECTWRAP_DOM.addEventListener('scroll', function () {
      const CONDITION = this.scrollHeight - this.scrollTop <= this.clientHeight
      if (CONDITION) {
        binding.value()
      }
    })
  }
})
Vue.config.devtools = true

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
